import { StrictMode, type ReactNode } from 'react'
import { RouterProvider } from '@tanstack/react-router'
import { QueryClientProvider } from '@tanstack/react-query'
import type { QueryClient } from '@tanstack/react-query'
import type { createAppRouter } from './router'

type AppRouter = ReturnType<typeof createAppRouter>

export function AppProviders({
  router,
  queryClient,
  children,
}: {
  router: AppRouter
  queryClient: QueryClient
  children?: ReactNode
}) {
  return (
    <StrictMode>
      <QueryClientProvider client={queryClient}>{children ?? <RouterProvider router={router} />}</QueryClientProvider>
    </StrictMode>
  )
}
